module.exports = __webpack_public_path__ + "img/img_16@2x.edaf99d4.png";